module.exports = __webpack_public_path__ + "header-bg.114d593511446b9a4c6e.png";


//////////////////
// WEBPACK FOOTER
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/assets/images/backgrounds/header-bg.png
// module id = ../../../../../src/assets/images/backgrounds/header-bg.png
// module chunks = styles